import { JsonServiceClient } from '@servicestack/client';
import { useMemo } from 'react';
import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { client } from '../api/client';
import { GetAdditionalPackageSessions, GetAdditionalPackageSessionsResponse } from '../api/dtos';
import { useGet } from '@ngt/forms';

const getData = (response?: SWRResponse<GetAdditionalPackageSessionsResponse, GetAdditionalPackageSessionsResponse>) => response?.data?.sessions;

const getError = (response?: SWRResponse<GetAdditionalPackageSessionsResponse, GetAdditionalPackageSessionsResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetAdditionalPackageSessionsResponse, GetAdditionalPackageSessionsResponse>) => ({
    additionalSessions: response?.data?.sessions
});

export const useAdditionalSessions = (id?: number, isAdmin?: boolean, isSpeaker?: boolean, isTAndECSpeaker?: boolean, isEarlyBird?: boolean, configuration?: SWRConfiguration ) => {
    const request = useMemo(() => {
        if(isEarlyBird){
            return ; // No additional sessions for early bird
        }

        return () => {
            return new GetAdditionalPackageSessions({id: id, isAdminSection: isAdmin, isSpeaker, isTAndECSpeaker});
        };

    }, [id, isAdmin, isSpeaker, isTAndECSpeaker])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useAdditionalSessions;